module.exports = __webpack_public_path__ + "static/img/025_TO8_1517.fddc16d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/025_TO8_1517.jpg
// module id = G2Ur
// module chunks = 0